import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import UserNameEmailQuery from './UserNameEmailQuery';

const UserNameEmailConnectorApollo = ({ children }) => {
    const { loading, data } = useQuery(UserNameEmailQuery);
    const result = {
        loading,
    };

    if (!loading) {
        result.userData = data.me;
    }
    return children(result);
};

UserNameEmailConnectorApollo.propTypes = {
    children: PropTypes.func.isRequired,
};

export default UserNameEmailConnectorApollo;
